import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { NewsItem } from '../models/news.model';


type NewsJsonDto = {
  ImageLink: string;
  Header: string;
  ShortDescription: string;
  Link: string;
  Date?: string;
};

@Injectable({ providedIn: 'root' })
export class NewsService {
  private readonly http = inject(HttpClient);

  fetchNews(): Observable<NewsItem[]> {
    return this.http.get<NewsJsonDto[]>('assets/mock-data/news.json').pipe(
      map((items) =>
        (items ?? []).map((x) => ({
          imageLink: x.ImageLink,
          header: x.Header,
          shortDescription: x.ShortDescription,
          link: x.Link,
          date: x.Date,
        })),
      ),
    );
  }
}
